import React from "react";
import {Box, Inline, TextBlock} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";
import {getLocalTime} from "shared/Utils/DateUtils";
import Write from "./Icons/Write";
import View from "./Icons/View";
import Clock from "./Icons/Clock";
import {IntlNamespaces} from "../../../../../translations/types";
import {
    INTL_MINUTE_SHORT_PLURAL,
    INTL_MINUTE_SHORT_SINGULAR,
} from "../../../../../translations/blogs";

const BlogStatistics = ({created, numberOfViews, readingTime, space = "small", color}) => {
    const {t} = useTranslation([IntlNamespaces.BLOGS, "months"]);
    const iconSize = {
        width: 20,
        height: 20,
    };
    const textStyles = {
        weight: 400,
        align: "center",
        size: "small",
    };
    const inlineStyles = {
        verticalAlign: "center",
        space: "xsmall",
    };
    const createdDate = `${getLocalTime(created).format("MMMM D, YYYY")}`;
    const createdDateSplitted = createdDate.split(" ");
    const createdMonth = createdDateSplitted[0];
    const createdRestOfDate = createdDateSplitted[1].concat(" ").concat(createdDateSplitted[2]);

    return (
        <Inline space={["small", space]} verticalAlign={"center"} wrap={"wrap"}>
            <Inline {...inlineStyles}>
                <Box paddingTop={"xxsmall"}>
                    <Write {...iconSize} color={color} />
                </Box>
                <TextBlock {...textStyles} data-test-id={"readingTime"}>
                    {`${readingTime} ${t(
                        `${IntlNamespaces.BLOGS}:${INTL_MINUTE_SHORT_SINGULAR.key}`,
                        parseInt(readingTime, 10) > 1
                            ? INTL_MINUTE_SHORT_PLURAL.defaultValue
                            : INTL_MINUTE_SHORT_SINGULAR.defaultValue,
                        {count: parseInt(readingTime, 10)},
                    )}`}
                </TextBlock>
            </Inline>

            <Inline {...inlineStyles}>
                <Box paddingTop={"xxsmall"}>
                    <View color={color} />
                </Box>
                <TextBlock {...textStyles} data-test-id={"numberOfViews"}>
                    {numberOfViews}
                </TextBlock>
            </Inline>
            <Inline {...inlineStyles}>
                <Box paddingTop={"xxsmall"}>
                    <Clock {...iconSize} color={color} />
                </Box>
                <TextBlock {...textStyles} data-test-id={"publishedDate"}>
                    {`${t(
                        `months:${createdMonth}.short`,
                        `${getLocalTime(created).format("MMM")}`,
                    )} ${createdRestOfDate}`}
                </TextBlock>
            </Inline>
        </Inline>
    );
};

export default BlogStatistics;
